var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion"},[_c('div',{staticClass:"accordion__container--blur"}),(!_vm.header)?_c('AccordionTitle',{attrs:{"title":_vm.title,"id":_vm.id,"open":_vm.open},on:{"toggle":_vm.onToggle}}):_vm._e(),_c('AccordionContent',{attrs:{"open":_vm.open}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }